import React, { useState, useEffect, createContext, useContext, useRef } from 'react';
import { useAuth } from '../hooks/Auth';

const REFRESH_TIME = 600 //3600
const BASE_URL = process.env.REACT_APP_BASE_URL?.trim() || ""

function useProvideEvents() {
  const ws = useRef(null)
  const auth = useAuth()
  const [error, setError] = useState(null)
  const [event, setEvent] = useState(null)
  const [time, setTime] = useState(Date.now())

  useEffect(() => setInterval(() => setTime(Date.now()), REFRESH_TIME * 1000), [])

  useEffect(() => {
    // React to events
    if (auth.token) {
      try {
        const url = BASE_URL + "/api/events?token=" + auth.token
        ws.current = new EventSource(url, { withCredentials: true })
        ws.current.onmessage = e => {
          if (e.data.includes("started") || e.data.includes("ping")) return
          setEvent(JSON.parse(e.data))
        }
        ws.current.onerror = e => {
          ws.current.close()
        }
        ws.current.onopen = e => {
          console.log("Opened event stream")
        }
        return () => {
          ws.current.close()
        }
      } catch (e) {
        setError(e)
        console.log(e)
      }
    }
  }, [auth.token, time])

  return { event, error}
}

const eventContext = createContext()

export function Events({ children }) {
  const events = useProvideEvents()
  return <eventContext.Provider value={events}>{children}</eventContext.Provider>
}

export default function useEvents() {
  return useContext(eventContext)
}